import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { useState } from 'react';
import { getAuthenticatedUser, saveAuthenticatedUser } from '../utils';
import fetchUser from './fetchUser';
function useUser(id, token) {
    const config = useConfig();
    const [user, setUser] = useState(getAuthenticatedUser());
    const [loading, setLoading] = useState(false);
    const setStateData = (newUser) => {
        saveAuthenticatedUser(newUser);
        setUser(newUser);
        setLoading(false);
    };
    if (!loading && id && (!user || user.uid !== id)) {
        setLoading(true);
        fetchUser(id, config.apiUrl, token)
            .then((result) => setStateData(result))
            .catch(() => setStateData(null));
    }
    return { user, loading };
}
export default useUser;
//# sourceMappingURL=useUser.js.map